import { axiosInstance } from "./request";

interface VipTypeList {
  goodsId?: number;
}

// 获取vip类型列表
export function getVipTypeList() {
  return axiosInstance.get(`/v1/goods/list`);
}

interface GoodsItemParam {
  goodsId: number;
}
// 下单
export function createVipOrder(params: GoodsItemParam) {
  return axiosInstance.post('/v1/order/create', params);
}

// 查询支付结果
export function queryVipOrder(orderId: string) {
  return axiosInstance.get(`/v1/order/query?orderId=${orderId}`);
}